import React from 'react';
import { useLanguage } from '../context/LanguageContext';

// Bilingual helpers for the lesson pages: T('it', 'en') for inline text, L({ it, en }) for data objects.
export const useT = () => {
  const { language } = useLanguage();
  return (it, en) => (language === 'en' ? en : it);
};

export const useL = () => {
  const { language } = useLanguage();
  return (v) => (v && typeof v === 'object' && !Array.isArray(v) && 'it' in v ? (language === 'en' ? v.en : v.it) : v);
};

export const LangToggle = ({ testid = 'lesson-lang-toggle' }) => {
  const { language, toggleLanguage } = useLanguage();
  return (
    <button onClick={toggleLanguage} data-testid={testid} aria-label="Language"
      className="inline-flex items-center rounded-full border border-cyan-500/30 bg-slate-900/70 p-0.5 text-[10px] font-bold uppercase tracking-widest">
      {['it', 'en'].map((l) => <span key={l} className={`rounded-full px-2.5 py-1 transition-colors ${language === l ? 'bg-orange-500 text-slate-950' : 'text-cyan-200'}`}>{l}</span>)}
    </button>
  );
};
